import { __decorate, __metadata } from 'tslib';
import { NotEnumerable, Type, Registry, getClass, nameOf, ProxyRegistry } from '@tencent/workbench-core';

/**
 * @internal
 */
class Provider {
    constructor(provide) {
        this.provide = provide;
        this._useClass = getClass(provide);
        this.overridable = false;
    }
    get className() {
        return nameOf(this.provide);
    }
    get useClass() {
        return this._useClass;
    }
    set useClass(value) {
        this._useClass = value;
    }
}
__decorate([
    NotEnumerable(),
    __metadata("design:type", Type)
], Provider.prototype, "_useClass", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", Object)
], Provider.prototype, "provide", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", Object)
], Provider.prototype, "instance", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", String)
], Provider.prototype, "type", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", Boolean)
], Provider.prototype, "singleton", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", Boolean)
], Provider.prototype, "supportDeferInvoke", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", Boolean)
], Provider.prototype, "overridable", void 0);
/**
 * 依赖注入容器
 *
 * @internal
 */
const ProviderRegistry = new Registry(Provider);
class ProxyProviderRegistry extends ProxyRegistry {
    constructor() {
        super(ProviderRegistry);
    }
}

export { Provider, ProviderRegistry, ProxyProviderRegistry };
//# sourceMappingURL=provider.js.map
